/* eslint-disable no-template-curly-in-string */
/*
  This file is automagically generated; please do not make any changes.
  - To update, run `yarn generate-docs` from the ./lib directory.
  - To override, add a corresponding .js file in components-override.

  Please refer to the `new-components-guide.md` for full instructions!
*/

let generatedDocs = {
  muiName: 'MuiAlert',
  description: '',
  displayName: 'Alert',
  methods: [],
  props: {
    action: {
      type: { name: 'node' },
      required: false,
      description:
        'The action to display. It renders after the message, at the end of the alertinline.',
    },
    children: {
      type: { name: 'node' },
      required: false,
      description: 'The content of the component.',
    },
    classes: {
      type: { name: 'object' },
      required: false,
      description:
        'Override or extend the styles applied to the component.\r\nSee [CSS API](#css) below for more details.',
    },
    className: {
      type: { name: 'string' },
      required: false,
      description: '@ignore',
    },
    closeText: {
      type: { name: 'string' },
      required: false,
      description:
        'Override the default label for the *close popup* icon button.\r\n\r\nFor localization purposes, you can use the provided [translations](/guides/localization/).',
      defaultValue: { value: "'Close'", computed: false },
    },
    color: {
      type: {
        name: 'enum',
        value: [
          { value: "'error'", computed: false },
          { value: "'info'", computed: false },
          { value: "'success'", computed: false },
          { value: "'warning'", computed: false },
        ],
      },
      required: false,
      description:
        'The main color for the alertinline. Unless provided, the value is taken from the `severity` prop.',
    },
    icon: {
      type: { name: 'node' },
      required: false,
      description:
        'Override the icon displayed before the children.\r\nUnless provided, the icon is mapped to the value of the `severity` prop.',
    },
    iconMapping: {
      type: {
        name: 'shape',
        value: {
          error: { name: 'node', required: false },
          info: { name: 'node', required: false },
          success: { name: 'node', required: false },
          warning: { name: 'node', required: false },
        },
      },
      required: false,
      description:
        'The component maps the `severity` prop to a range of different icons,\r\nfor instance success to `<SuccessOutlined>`.\r\nIf you wish to change this mapping, you can provide your own.\r\nAlternatively, you can use the `icon` prop to override the icon displayed.',
      defaultValue: {
        value:
          '{\n  success: /*#__PURE__*/React.createElement(SuccessOutlinedIcon, {\n    fontSize: "inherit"\n  }),\n  warning: /*#__PURE__*/React.createElement(ReportProblemOutlinedIcon, {\n    fontSize: "inherit"\n  }),\n  error: /*#__PURE__*/React.createElement(ErrorOutlineIcon, {\n    fontSize: "inherit"\n  }),\n  info: /*#__PURE__*/React.createElement(InfoOutlinedIcon, {\n    fontSize: "inherit"\n  })\n}',
        computed: false,
      },
    },
    onClose: {
      type: { name: 'func' },
      required: false,
      description:
        'Callback fired when the component requests to be closed.\r\nWhen provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.\r\n\r\n@param {object} event The event source of the callback.',
    },
    role: {
      type: { name: 'string' },
      required: false,
      description: 'The ARIA role attribute of the element.',
      defaultValue: { value: "'alert'", computed: false },
    },
    severity: {
      type: {
        name: 'enum',
        value: [
          { value: "'error'", computed: false },
          { value: "'info'", computed: false },
          { value: "'success'", computed: false },
          { value: "'warning'", computed: false },
        ],
      },
      required: false,
      description:
        'The severity of the alertinline. This defines the color and icon used.',
      defaultValue: { value: "'success'", computed: false },
    },
    variant: {
      type: {
        name: 'enum',
        value: [
          { value: "'filled'", computed: false },
          { value: "'outlined'", computed: false },
          { value: "'standard'", computed: false },
        ],
      },
      required: false,
      description: 'The variant to use.',
      defaultValue: { value: "'standard'", computed: false },
    },
  },
  styles: {
    root: { description: 'Styles applied to the root element.' },
    standardSuccess: {
      description:
        'Styles applied to the root element if `variant="standard"` and `color="success"`.',
    },
    standardInfo: {
      description:
        'Styles applied to the root element if `variant="standard"` and `color="info"`.',
    },
    standardWarning: {
      description:
        'Styles applied to the root element if `variant="standard"` and `color="warning"`.',
    },
    standardError: {
      description:
        'Styles applied to the root element if `variant="standard"` and `color="error"`.',
    },
    outlinedSuccess: {
      description:
        'Styles applied to the root element if `variant="outlined"` and `color="success"`.',
    },
    outlinedInfo: {
      description:
        'Styles applied to the root element if `variant="outlined"` and `color="info"`.',
    },
    outlinedWarning: {
      description:
        'Styles applied to the root element if `variant="outlined"` and `color="warning"`.',
    },
    outlinedError: {
      description:
        'Styles applied to the root element if `variant="outlined"` and `color="error"`.',
    },
    filledSuccess: {
      description:
        'Styles applied to the root element if `variant="filled"` and `color="success"`.',
    },
    filledInfo: {
      description:
        'Styles applied to the root element if `variant="filled"` and `color="info"`.',
    },
    filledWarning: {
      description:
        'Styles applied to the root element if `variant="filled"` and `color="warning"`.',
    },
    filledError: {
      description:
        'Styles applied to the root element if `variant="filled"` and `color="error"`.',
    },
    icon: { description: 'Styles applied to the icon wrapper element.' },
    message: { description: 'Styles applied to the message wrapper element.' },
    action: {
      description:
        'Styles applied to the action wrapper element if `action` is provided.',
    },
  },
}
export default generatedDocs
